import React from "react";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col, Row } from "react-bootstrap";
import { SignupCompanyLogo } from "../widget/SignupWidgets";
import {
  SignupCityField,
  SignupEmailField,
  SignupFirstNameField,
  SignupLastNameField,
  SignupPasswordConfimField,
  SignupPasswordField,
  SignupPhoneField,
} from "./widget/SignupPersonalInformationTextfields";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { termsExternalLinks } from "../../../../const/ExternalLinks";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { SignupPersonalInformationContextImport } from "../../../../provider/onboarding/signup/personal_information/SignupPersonalInformationContextProvider";
import { useDispatch } from "react-redux";
import { addModal } from "../../../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../../../const/ModalKeys";

const SignupPersonalInformationContent = (props: { type: number }) => {
  const type: number = props.type;
  const dispatch = useDispatch();

  const { agreeStatus, toggleAgreeStatus, verificationType } =
    SignupPersonalInformationContextImport();

  const handleLink = (name: string, url: string) => {
    if (UtilityHelper.isNotEmpty(name) && UtilityHelper.isNotEmpty(url)) {
      if (type === 3) {
        UtilityHelper.navigateTab(url);
      } else {
        dispatch(
          addModal({
            id: ModalKeys.web_view,
            size: "lg",
            screenMobileView: true,

            title: name,
            webViewUrl: url,
          })
        );
      }
    }
  };

  return (
    <Div className="h-100 d-center">
      <Div>
        <Center>
          <SignupCompanyLogo
            title={AppTranslation.text("personal_information")}
          />
        </Center>
        <Col xs={12} sm={10} md={8} className="mx-auto px-lg-4 px-lg-2">
          <form autoComplete="off">
            <Row>
              <Col xs={12} lg={6}>
                <SignupFirstNameField />
              </Col>
              <Col xs={12} lg={6}>
                <SignupLastNameField />
              </Col>
              <Col xs={12} lg={6}>
                {verificationType === "email" ? (
                  <SignupEmailField />
                ) : (
                  <SignupPhoneField />
                )}
              </Col>
              <Col xs={12} lg={6}>
                {verificationType === "email" ? (
                  <SignupPhoneField />
                ) : (
                  <SignupEmailField />
                )}
              </Col>
              <Col xs={12} lg={6}>
                <SignupPasswordField />
              </Col>
              <Col xs={12} lg={6}>
                <SignupPasswordConfimField />
              </Col>
              <Col xs={12} lg={6}>
                <SignupCityField />
              </Col>
            </Row>
          </form>
          <Div
            className={
              "d-block d-lg-flex align-items-center justify-content-lg-center pt-3 pb-5 pb-lg-0"
            }
          >
            <div
              role="button"
              onClick={() => toggleAgreeStatus()}
              className="d-flex align-items-center justify-content-lg-center"
            >
              <CheckBoxRound status={agreeStatus} />
              <TextBlock
                fontSize="12_14"
                fontName="book"
                textColor="theme-label"
                center={true}
                className="ps-3"
              >
                {AppTranslation.text("i_accept_communicatr")}
              </TextBlock>
            </div>
            <div
              role="button"
              onClick={() =>
                handleLink(
                  AppTranslation.text("terms_condition"),
                  termsExternalLinks.term_of_use
                )
              }
            >
              <TextBlock
                fontSize="12_14"
                fontName="book"
                textColor="theme-sublabel"
                className="ps-4 ms-2 ms-lg-0 ps-lg-1"
              >
                {AppTranslation.text("terms_condition")}
              </TextBlock>
            </div>
            <div
              role="button"
              onClick={() =>
                handleLink(
                  AppTranslation.text("privacy_policy"),
                  termsExternalLinks.privacy_policy
                )
              }
              className="ps-4 ms-2 ms-lg-0 ps-lg-1"
            >
              <TextBlock
                fontSize="12_14"
                fontName="book"
                textColor="theme-sublabel"
              >
                {AppTranslation.text("privacy_policy")}
              </TextBlock>
            </div>
            <div
              role="button"
              onClick={() =>
                handleLink(
                  AppTranslation.text("disclaimer"),
                  termsExternalLinks.disclaimer
                )
              }
              className="ps-4 ms-2 ms-lg-0 ps-lg-1"
            >
              <TextBlock
                fontSize="12_14"
                fontName="book"
                textColor="theme-sublabel"
              >
                {AppTranslation.text("disclaimer")}
              </TextBlock>
            </div>
            <div
              role="button"
              onClick={() =>
                handleLink(
                  AppTranslation.text("end_user_agreement"),
                  termsExternalLinks.enduser_agreement
                )
              }
              className="ps-4 ms-2 ms-lg-0 ps-lg-1"
            >
              <TextBlock
                fontSize="12_14"
                fontName="book"
                textColor="theme-sublabel"
              >
                {AppTranslation.text("end_user_agreement")}
              </TextBlock>
            </div>
          </Div>
        </Col>
      </Div>
    </Div>
  );
};

export default SignupPersonalInformationContent;
